if (!customElements.get("icon-list")) {
  class IconList extends HTMLElement {
    constructor() {
      super();

      this.iconListInner = this.querySelector(".icon-list__inner");
      this.iconItems = Array.from(this.querySelectorAll("icon-item"));
    }

    connectedCallback() {
      this.addEventListener("prev-next:prev", this.previous.bind(this));
      this.addEventListener("prev-next:next", this.next.bind(this));

      if (!this.hidden && this.staggerApparition) {
        this._staggerIconsApparition();
      }
    }

    get staggerApparition() {
      return this.hasAttribute("stagger-apparition");
    }

    get apparitionAnimation() {
      return (this._animation =
        this._animation ||
        new CustomAnimation(
          new ParallelEffect(
            this.iconItems.map((item, index) => {
              return new CustomKeyframeEffect(
                item,
                {
                  opacity: [0, 1],
                  transform: [
                    `translateY(${
                      MediaFeatures.prefersReducedMotion()
                        ? 0
                        : window.innerWidth < 1e3
                        ? 35
                        : 60
                    }px)`,
                    "translateY(0)",
                  ],
                },
                {
                  duration: 600,
                  delay: MediaFeatures.prefersReducedMotion()
                    ? 0
                    : 100 * index - Math.min(3 * index * index, 100 * index),
                  easing: "ease",
                }
              );
            })
          )
        ));
    }

    previous(event) {
      console.log("Rich text: previous");

      const directionFlip =
          window.themeVariables.settings.direction === "ltr" ? 1 : -1,
        columnGap = parseInt(
          getComputedStyle(this).getPropertyValue("--icon-list-column-gap")
        );

      event.target.nextElementSibling.removeAttribute("disabled");
      event.target.toggleAttribute(
        "disabled",
        this.iconListInner.scrollLeft * directionFlip -
          (this.iconListInner.clientWidth + columnGap) <=
          0
      );

      this.iconListInner.scrollBy({
        left: -(this.iconListInner.clientWidth + columnGap) * directionFlip,
        behavior: "smooth",
      });
    }

    next(event) {
      console.log("Rich text: next");

      const directionFlip =
          window.themeVariables.settings.direction === "ltr" ? 1 : -1,
        columnGap = parseInt(
          getComputedStyle(this).getPropertyValue("--icon-list-column-gap")
        );

      event.target.previousElementSibling.removeAttribute("disabled");
      event.target.toggleAttribute(
        "disabled",
        this.iconListInner.scrollLeft * directionFlip +
          (this.iconListInner.clientWidth + columnGap) * 2 >=
          this.iconListInner.scrollWidth
      );

      this.iconListInner.scrollBy({
        left: (this.iconListInner.clientWidth + columnGap) * directionFlip,
        behavior: "smooth",
      });
    }

    attributeChangedCallback(name) {
      var _a, _b;

      if (!this.staggerApparition) {
        return;
      }

      switch (name) {
        case "hidden":
          if (!this.hidden) {
            this.iconListInner.scrollLeft = 0;
            this.iconListInner.parentElement.scrollLeft = 0;

            (_a = this.querySelector(".prev-next-button--prev")) == null
              ? void 0
              : _a.setAttribute("disabled", "");

            (_b = this.querySelector(".prev-next-button--next")) == null
              ? void 0
              : _b.removeAttribute("disabled");

            this._staggerIconsApparition();
          } else {
            this.apparitionAnimation.finish();
          }
      }
    }

    async _staggerIconsApparition() {
      this.iconItems.forEach((item) => (item.style.opacity = 0));

      await this.untilVisible({
        threshold:
          this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
      });

      this.apparitionAnimation.play();
    }
  }

  customElements.define("icon-list", IconList);
}
